import { EFileUploadActionsES, FileUploadActionsES } from "@edp-store/actions/ES/file-upload-es.actions";
import { IFileUploadStateES, initialFileUploadStateES } from "@edp-store/state/ES/file-upload-es.state";


export function fileUploadReducersES(state = initialFileUploadStateES, action: FileUploadActionsES): IFileUploadStateES {
    switch (action.type) {
        /* case EFileUploadActionsES.SaveUploadedFile: {
            return {
                ...state,
                uploadedFile: action.payload,
            };
        }
        case EFileUploadActions.ClearUploadedFile: {
            return {
                ...state,
                uploadedFile: null,
            };
        }
        case EFileUploadActions.ClearAndroidFile: {
            return {
                ...state,
                androidFile: null,
            };
        }
        case EFileUploadActions.RemoveUploadedFile: {
            return {
                ...state,
                uploadedFiles: state.uploadedFiles.filter(item => item.name !== action.payload.name),
            };
        } */
        case EFileUploadActionsES.ClearUploadedFiles: {
            return {
                ...state,
                uploadedFiles: [],
            };
        }
        case EFileUploadActionsES.AddUploadedFile: {
            return {
                ...state,
                uploadedFiles: (() => {
                    const array = state.uploadedFiles.filter(item => item.name !== action.payload.name);
                    return [...array, action.payload];
                })(),
            };
        }
        default: {
            return state;
        }
    }
}
